<template>
  <div>
    
    <b-container>
  
      <b-row class="justify-content-md-center">
        <b-col>

          <b-card
            img-top
            title="Complemento de Cadastro"
            subTitle="Preencha as informações abaixo para complementar seu cadastro e da sua empresa."
            style="border-radius: unset;"
          >

            <form-wizard
              ref="wizard"
              color="#7367F0"
              :title="null"
              :subtitle="null"
              finish-button-text="Finalizar"
              next-button-text="Avançar"
              back-button-text="Voltar"
              class="steps-transparent mb-3"
              @on-complete="formSubmitted"
              @on-change="tabChange"
            >
              <!-- Natural entity tab -->
              <tab-content
                title="Dados Pessoais"
                icon="feather icon-user"
              >
                <NaturalEntity
                  ref="naturalEntityRef"
                  :naturalEntityId="naturalEntityId"
                  :services="services"
                  :key="id"
                  :isComplement="true"
                />
              </tab-content>

              <!-- Legal entity tab -->
              <tab-content
                title="Pessoa Jurídica - Dados Básicos"
                icon="feather icon-home"
              >

                <b-alert
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    Complemente os dados da Pessoa Jurídica e adicione um ou mais responsáveis.
                  </div>
                </b-alert>

                <LegalEntityForm
                  ref="legalEntityRef"
                  :legalEntityId="legal_entity_id"
                  :services="services"
                  :isComplement="true"
                />
              </tab-content>

              <!-- Legal entity tab -->
              <tab-content
                title="Pessoa Jurídica - Dados Complementares"
                icon="feather icon-home"
                :before-change="beforeAddressPhone"
              >
                
                <b-alert
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    Adicione no mínimo um telefone e um endereço.
                  </div>
                </b-alert>

                <b-card 
                  title="Telefone" 
                  sub-title="Adicione na lista abaixo os telefones da pessoa jurídica"
                  class="border-secondary"
                >

                  <Phone ref="phoneRef" :services="services" />
                  
                </b-card>

                <b-card 
                  title="Endereço"
                  sub-title="Adicione na lista abaixo os endereços da pessoa jurídica"
                  class="border-secondary"
                >
                  <Address ref="addressRef" :services="services" :addressTypeList="addressTypeList"/>
                </b-card>
                
              </tab-content>

              <!-- Organizational Unit -->
              <tab-content
                title="Unidade Organizacional"
                icon="feather icon-grid"
                :before-change="beforeOrganizationalUnit"
              >

                <b-alert
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    Adicione uma unidade organizacional e vincule-a a um ou mais responsáveis.
                  </div>
                </b-alert>

                <div class="mt-2">
                  <OrganizationalUnitList
                    ref="organizationalUnitRef"
                    :services="services" 
                    :legalEntityId="legal_entity_id">
                  </OrganizationalUnitList>
                </div>
                
              </tab-content>

            </form-wizard>
            
          </b-card>
          
        </b-col>
      </b-row>

    </b-container>

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BForm, BButton, BFormInput, BFormGroup, BCard, BCardTitle, BCardBody, BContainer, BAlert } from 'bootstrap-vue'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { FormWizard, TabContent } from 'vue-form-wizard'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'

import NaturalEntity from '@/views/apps/people/tabs/NaturalEntity.vue'
import LegalEntityForm from '@/views/apps/people/tabs/LegalEntityForm.vue'
import Phone from '@/views/apps/people/tabs/Phone.vue'
import Address from '@/views/apps/people/tabs/Address.vue'
import OrganizationalUnitList from '@/views/apps/people/tabs/OrganizationalUnitList.vue'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import PeopleService from '@/services/api/PeopleService'
import NaturalEntityService from '@/services/api/NaturalEntityService'
import LegalEntityService from '@/services/api/LegalEntityService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import DocumentTypeService from '@/services/api/DocumentTypeService'
import DocumentPeopleService from '@/services/api/DocumentPeopleService'
import OccupationService from '@/services/api/OccupationService'
import PronounTreatmentService from '@/services/api/PronounTreatmentService'
import PositionService from '@/services/api/PositionService'
import EmployeeService from '@/services/api/EmployeeService'
import WorkingTimeService from '@/services/api/WorkingTimeService'
import OrganizationalUnitService from '@/services/api/OrganizationalUnitService'
import OrganizationalUnitSponsorService from '@/services/api/OrganizationalUnitSponsorService'

export default {
  directives: {
    Ripple,
  },
  components: {
    NaturalEntity,
    LegalEntityForm,
    Phone,
    Address,
    OrganizationalUnitList,
    Datepicker,
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    BCardTitle,
    BCardBody,
    BContainer,
    BAlert,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    legal_entity_id: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      naturalEntityService: null,
      legalEntityService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      documentTypeService: null,
      documentPeopleService: null,
      occupationService: null,
      pronounTreatmentService: null,
      positionService: null,
      employeeService: null,
      workingTimeService: null,
      organizationalUnitService: null,
      organizationalUnitSponsorService: null,
    },
    naturalEntityId: null,
    addressTypeList: [],
    // validation rules
    required,
  }),
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.address.addressType) &&
        !this.isEmpty(this.address.streetName) &&
        !this.isEmpty(this.address.city)
      )
    },
    showCityList() {
      return this.cityList.length > 0
    }
  },
  watch: {},
  methods: {
    beforeAddressPhone() {
      const phoneQuantity = this.$refs.phoneRef.phoneQuantity()
      const addressQuantity = this.$refs.addressRef.addressQuantity()

      if (phoneQuantity === 0 || addressQuantity === 0) {
        this.notifyWarning(this.$vs, 'Para avançar por favor adicione um telefone e um endereço da pessoa jurídica.')
        return false
      }
      return true
    },
    beforeOrganizationalUnit() {
      const list = this.$refs.organizationalUnitRef.organizationalUnitsList()
      if (list.length > 0) {
        return true
      }
      return false
    },
    tabChange(prevIndex, nextIndex) {
      if (nextIndex > prevIndex) {
        if (prevIndex === 0) {
          this.$refs.naturalEntityRef.saveNaturalEntity()
        } else if (prevIndex === 1) {
          this.$refs.legalEntityRef.saveLegalEntityForm()
        }
      }
    },
    formSubmitted() {
      const list = this.$refs.organizationalUnitRef.organizationalUnitsList()
      if (list.length === 0) {
        this.notifyWarning(this.$vs, 'Para avançar por favor adicione uma unidade organizacional.')
      } else {
        this.notifySuccess(this.$vs, 'Complementação realizada com sucesso, aguarde o sistema carregar.', 5000)

        const user = this.$store.state.AppActiveUser
        if (user) {
          user.uncomplete_legal_entity_id = -1
          this.$store.commit('UPDATE_USER_INFO', user)
          this.$router.push('/')
        }
      }
    }
  },
  beforeMount() {

    const user = this.$store.state.AppActiveUser
    if (user && user.natural_entity_id) {
      this.naturalEntityId = user.natural_entity_id
    }

    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.peopleService = PeopleService.build(this.$vs)
    this.services.naturalEntityService = NaturalEntityService.build(this.$vs)
    this.services.legalEntityService = LegalEntityService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(
      this.$vs
    )
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.documentTypeService = DocumentTypeService.build(this.$vs)
    this.services.documentPeopleService = DocumentPeopleService.build(this.$vs)
    this.services.occupationService = OccupationService.build(this.$vs)
    this.services.pronounTreatmentService = PronounTreatmentService.build(this.$vs)
    this.services.positionService = PositionService.build(this.$vs)
    this.services.employeeService = EmployeeService.build(this.$vs)
    this.services.workingTimeService = WorkingTimeService.build(this.$vs)
    this.services.organizationalUnitService = OrganizationalUnitService.build(this.$vs)
    this.services.organizationalUnitSponsorService = OrganizationalUnitSponsorService.build(this.$vs)

    this.services.addressTypeService.all().then(
      data => {
        this.addressTypeList = data
        this.$vs.loading.close()
      },
      error => {
        this.$vs.loading.close()
      }
    )
  },
  mounted() {

    this.$root.$on('naturalEntityError', () => {
      if (this.$refs.wizard) {
        this.$refs.wizard.prevTab()
      }
    })

  }
}
</script>